import { combineReducers } from "redux";
import openMenu from "./menu";
import userType from "./userType";
import changePage from "./changePage";
import saveFilters from "./saveFilters";

export default combineReducers({
  changePage,
  openMenu,
  saveFilters,
  userType,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js